import { Code, ConnectError } from '@connectrpc/connect'

/**
 * OCCTO マスタ各タブの編集モーダル GET 操作で共通の ConnectError → エラーメッセージ変換。
 *
 * 編集モーダルを開いた瞬間に GET が失敗した場合、対象レコードが削除済みか
 * (NotFound) 通信エラー等か (それ以外) でユーザーが取るべきアクション
 * (一覧再読み込み vs 時間をおいてリトライ) が異なる (spec AC-MOI-016 /
 * AC-MOI-016b)。 `errorKeyPrefix` に各マスタの
 * `page:adminOcctoMaster.<master>.serverError` を渡すことで、 notFound /
 * loadFailed の 2 文言を引き分ける。
 */
export function mapMasterGetError(
  t: (key: string) => string,
  err: unknown,
  errorKeyPrefix: string,
): string {
  if (err instanceof ConnectError && err.code === Code.NotFound) {
    return t(`${errorKeyPrefix}.notFound`)
  }
  return t(`${errorKeyPrefix}.loadFailed`)
}
